// Códigos telefónicos por país para el selector de WhatsApp.
//
// Cada país lleva su propio `id` (ISO 3166-1 alfa-2) porque varios comparten
// prefijo (+1 = USA, Canadá, Puerto Rico, Rep. Dominicana...; +7 = Rusia y
// Kazajistán). Si el <select> usara el prefijo como valor, elegir "Rep.
// Dominicana" saltaría a "USA" y el país no aparecería nunca.
//
// El listado va ordenado por NOMBRE: quien busca su país en la rueda del
// iPhone lo busca alfabéticamente, no por prefijo. Con el orden por número,
// Bolivia (+591) quedaba enterrada detrás de ~150 países y un lead de Bolivia
// creyó que no estaba.

export const CODIGO_PAIS_DEFAULT = 'CL';

// Los que más escriben: van arriba, antes del listado completo.
const IDS_FRECUENTES = [
  'CL', 'AR', 'BO', 'CO', 'EC', 'ES', 'US', 'MX', 'PE', 'PY', 'UY', 'VE',
];

const PAISES = [
  { id: 'AF', code: '+93', country: 'Afganistán' },
  { id: 'AL', code: '+355', country: 'Albania' },
  { id: 'DE', code: '+49', country: 'Alemania' },
  { id: 'AD', code: '+376', country: 'Andorra' },
  { id: 'AO', code: '+244', country: 'Angola' },
  { id: 'AI', code: '+1', country: 'Anguila' },
  { id: 'AG', code: '+1', country: 'Antigua y Barbuda' },
  { id: 'SA', code: '+966', country: 'Arabia Saudita' },
  { id: 'DZ', code: '+213', country: 'Argelia' },
  { id: 'AR', code: '+54', country: 'Argentina' },
  { id: 'AM', code: '+374', country: 'Armenia' },
  { id: 'AW', code: '+297', country: 'Aruba' },
  { id: 'AU', code: '+61', country: 'Australia' },
  { id: 'AT', code: '+43', country: 'Austria' },
  { id: 'AZ', code: '+994', country: 'Azerbaiyán' },
  { id: 'BS', code: '+1', country: 'Bahamas' },
  { id: 'BD', code: '+880', country: 'Bangladés' },
  { id: 'BB', code: '+1', country: 'Barbados' },
  { id: 'BH', code: '+973', country: 'Baréin' },
  { id: 'BE', code: '+32', country: 'Bélgica' },
  { id: 'BZ', code: '+501', country: 'Belice' },
  { id: 'BJ', code: '+229', country: 'Benín' },
  { id: 'BM', code: '+1', country: 'Bermudas' },
  { id: 'BY', code: '+375', country: 'Bielorrusia' },
  { id: 'BO', code: '+591', country: 'Bolivia' },
  { id: 'BA', code: '+387', country: 'Bosnia y Herzegovina' },
  { id: 'BW', code: '+267', country: 'Botsuana' },
  { id: 'BR', code: '+55', country: 'Brasil' },
  { id: 'BN', code: '+673', country: 'Brunéi' },
  { id: 'BG', code: '+359', country: 'Bulgaria' },
  { id: 'BF', code: '+226', country: 'Burkina Faso' },
  { id: 'BI', code: '+257', country: 'Burundi' },
  { id: 'BT', code: '+975', country: 'Bután' },
  { id: 'CV', code: '+238', country: 'Cabo Verde' },
  { id: 'KH', code: '+855', country: 'Camboya' },
  { id: 'CM', code: '+237', country: 'Camerún' },
  { id: 'CA', code: '+1', country: 'Canadá' },
  { id: 'QA', code: '+974', country: 'Catar' },
  { id: 'TD', code: '+235', country: 'Chad' },
  { id: 'CL', code: '+56', country: 'Chile' },
  { id: 'CN', code: '+86', country: 'China' },
  { id: 'CY', code: '+357', country: 'Chipre' },
  { id: 'CO', code: '+57', country: 'Colombia' },
  { id: 'KM', code: '+269', country: 'Comoras' },
  { id: 'CG', code: '+242', country: 'Congo' },
  { id: 'KP', code: '+850', country: 'Corea del Norte' },
  { id: 'KR', code: '+82', country: 'Corea del Sur' },
  { id: 'CI', code: '+225', country: 'Costa de Marfil' },
  { id: 'CR', code: '+506', country: 'Costa Rica' },
  { id: 'HR', code: '+385', country: 'Croacia' },
  { id: 'CU', code: '+53', country: 'Cuba' },
  { id: 'CW', code: '+599', country: 'Curazao / Bonaire' },
  { id: 'DK', code: '+45', country: 'Dinamarca' },
  { id: 'DM', code: '+1', country: 'Dominica' },
  { id: 'EC', code: '+593', country: 'Ecuador' },
  { id: 'EG', code: '+20', country: 'Egipto' },
  { id: 'SV', code: '+503', country: 'El Salvador' },
  { id: 'AE', code: '+971', country: 'Emiratos Árabes Unidos' },
  { id: 'ER', code: '+291', country: 'Eritrea' },
  { id: 'SK', code: '+421', country: 'Eslovaquia' },
  { id: 'SI', code: '+386', country: 'Eslovenia' },
  { id: 'ES', code: '+34', country: 'España' },
  { id: 'US', code: '+1', country: 'Estados Unidos' },
  { id: 'EE', code: '+372', country: 'Estonia' },
  { id: 'SZ', code: '+268', country: 'Esuatini' },
  { id: 'ET', code: '+251', country: 'Etiopía' },
  { id: 'PH', code: '+63', country: 'Filipinas' },
  { id: 'FI', code: '+358', country: 'Finlandia' },
  { id: 'FJ', code: '+679', country: 'Fiyi' },
  { id: 'FR', code: '+33', country: 'Francia' },
  { id: 'GA', code: '+241', country: 'Gabón' },
  { id: 'GM', code: '+220', country: 'Gambia' },
  { id: 'GE', code: '+995', country: 'Georgia' },
  { id: 'GH', code: '+233', country: 'Ghana' },
  { id: 'GI', code: '+350', country: 'Gibraltar' },
  { id: 'GD', code: '+1', country: 'Granada' },
  { id: 'GR', code: '+30', country: 'Grecia' },
  { id: 'GL', code: '+299', country: 'Groenlandia' },
  { id: 'GP', code: '+590', country: 'Guadalupe' },
  { id: 'GU', code: '+1', country: 'Guam' },
  { id: 'GT', code: '+502', country: 'Guatemala' },
  { id: 'GF', code: '+594', country: 'Guayana Francesa' },
  { id: 'GN', code: '+224', country: 'Guinea' },
  { id: 'GQ', code: '+240', country: 'Guinea Ecuatorial' },
  { id: 'GW', code: '+245', country: 'Guinea-Bisáu' },
  { id: 'GY', code: '+592', country: 'Guyana' },
  { id: 'HT', code: '+509', country: 'Haití' },
  { id: 'HN', code: '+504', country: 'Honduras' },
  { id: 'HK', code: '+852', country: 'Hong Kong' },
  { id: 'HU', code: '+36', country: 'Hungría' },
  { id: 'IN', code: '+91', country: 'India' },
  { id: 'ID', code: '+62', country: 'Indonesia' },
  { id: 'IQ', code: '+964', country: 'Irak' },
  { id: 'IR', code: '+98', country: 'Irán' },
  { id: 'IE', code: '+353', country: 'Irlanda' },
  { id: 'IS', code: '+354', country: 'Islandia' },
  { id: 'KY', code: '+1', country: 'Islas Caimán' },
  { id: 'CK', code: '+682', country: 'Islas Cook' },
  { id: 'FO', code: '+298', country: 'Islas Feroe' },
  { id: 'FK', code: '+500', country: 'Islas Malvinas' },
  { id: 'MH', code: '+692', country: 'Islas Marshall' },
  { id: 'SB', code: '+677', country: 'Islas Salomón' },
  { id: 'TC', code: '+1', country: 'Islas Turcas y Caicos' },
  { id: 'VG', code: '+1', country: 'Islas Vírgenes Británicas' },
  { id: 'VI', code: '+1', country: 'Islas Vírgenes de EE. UU.' },
  { id: 'IL', code: '+972', country: 'Israel' },
  { id: 'IT', code: '+39', country: 'Italia' },
  { id: 'JM', code: '+1', country: 'Jamaica' },
  { id: 'JP', code: '+81', country: 'Japón' },
  { id: 'JO', code: '+962', country: 'Jordania' },
  { id: 'KZ', code: '+7', country: 'Kazajistán' },
  { id: 'KE', code: '+254', country: 'Kenia' },
  { id: 'KG', code: '+996', country: 'Kirguistán' },
  { id: 'KI', code: '+686', country: 'Kiribati' },
  { id: 'XK', code: '+383', country: 'Kosovo' },
  { id: 'KW', code: '+965', country: 'Kuwait' },
  { id: 'LA', code: '+856', country: 'Laos' },
  { id: 'LS', code: '+266', country: 'Lesoto' },
  { id: 'LV', code: '+371', country: 'Letonia' },
  { id: 'LB', code: '+961', country: 'Líbano' },
  { id: 'LR', code: '+231', country: 'Liberia' },
  { id: 'LY', code: '+218', country: 'Libia' },
  { id: 'LI', code: '+423', country: 'Liechtenstein' },
  { id: 'LT', code: '+370', country: 'Lituania' },
  { id: 'LU', code: '+352', country: 'Luxemburgo' },
  { id: 'MO', code: '+853', country: 'Macao' },
  { id: 'MK', code: '+389', country: 'Macedonia del Norte' },
  { id: 'MG', code: '+261', country: 'Madagascar' },
  { id: 'MY', code: '+60', country: 'Malasia' },
  { id: 'MW', code: '+265', country: 'Malaui' },
  { id: 'MV', code: '+960', country: 'Maldivas' },
  { id: 'ML', code: '+223', country: 'Malí' },
  { id: 'MT', code: '+356', country: 'Malta' },
  { id: 'MA', code: '+212', country: 'Marruecos' },
  { id: 'MQ', code: '+596', country: 'Martinica' },
  { id: 'MU', code: '+230', country: 'Mauricio' },
  { id: 'MR', code: '+222', country: 'Mauritania' },
  { id: 'MX', code: '+52', country: 'México' },
  { id: 'FM', code: '+691', country: 'Micronesia' },
  { id: 'MD', code: '+373', country: 'Moldavia' },
  { id: 'MC', code: '+377', country: 'Mónaco' },
  { id: 'MN', code: '+976', country: 'Mongolia' },
  { id: 'ME', code: '+382', country: 'Montenegro' },
  { id: 'MS', code: '+1', country: 'Montserrat' },
  { id: 'MZ', code: '+258', country: 'Mozambique' },
  { id: 'MM', code: '+95', country: 'Myanmar' },
  { id: 'NA', code: '+264', country: 'Namibia' },
  { id: 'NR', code: '+674', country: 'Nauru' },
  { id: 'NP', code: '+977', country: 'Nepal' },
  { id: 'NI', code: '+505', country: 'Nicaragua' },
  { id: 'NE', code: '+227', country: 'Níger' },
  { id: 'NG', code: '+234', country: 'Nigeria' },
  { id: 'NU', code: '+683', country: 'Niue' },
  { id: 'NO', code: '+47', country: 'Noruega' },
  { id: 'NC', code: '+687', country: 'Nueva Caledonia' },
  { id: 'NZ', code: '+64', country: 'Nueva Zelanda' },
  { id: 'OM', code: '+968', country: 'Omán' },
  { id: 'NL', code: '+31', country: 'Países Bajos' },
  { id: 'PK', code: '+92', country: 'Pakistán' },
  { id: 'PW', code: '+680', country: 'Palaos' },
  { id: 'PS', code: '+970', country: 'Palestina' },
  { id: 'PA', code: '+507', country: 'Panamá' },
  { id: 'PG', code: '+675', country: 'Papúa Nueva Guinea' },
  { id: 'PY', code: '+595', country: 'Paraguay' },
  { id: 'PE', code: '+51', country: 'Perú' },
  { id: 'PF', code: '+689', country: 'Polinesia Francesa' },
  { id: 'PL', code: '+48', country: 'Polonia' },
  { id: 'PT', code: '+351', country: 'Portugal' },
  { id: 'PR', code: '+1', country: 'Puerto Rico' },
  { id: 'GB', code: '+44', country: 'Reino Unido' },
  { id: 'CF', code: '+236', country: 'República Centroafricana' },
  { id: 'CZ', code: '+420', country: 'República Checa' },
  { id: 'CD', code: '+243', country: 'República Democrática del Congo' },
  { id: 'DO', code: '+1', country: 'República Dominicana' },
  { id: 'RE', code: '+262', country: 'Reunión / Mayotte' },
  { id: 'RW', code: '+250', country: 'Ruanda' },
  { id: 'RO', code: '+40', country: 'Rumania' },
  { id: 'RU', code: '+7', country: 'Rusia' },
  { id: 'WS', code: '+685', country: 'Samoa' },
  { id: 'KN', code: '+1', country: 'San Cristóbal y Nieves' },
  { id: 'SM', code: '+378', country: 'San Marino' },
  { id: 'PM', code: '+508', country: 'San Pedro y Miquelón' },
  { id: 'VC', code: '+1', country: 'San Vicente y las Granadinas' },
  { id: 'SH', code: '+290', country: 'Santa Elena' },
  { id: 'LC', code: '+1', country: 'Santa Lucía' },
  { id: 'ST', code: '+239', country: 'Santo Tomé y Príncipe' },
  { id: 'SN', code: '+221', country: 'Senegal' },
  { id: 'RS', code: '+381', country: 'Serbia' },
  { id: 'SC', code: '+248', country: 'Seychelles' },
  { id: 'SL', code: '+232', country: 'Sierra Leona' },
  { id: 'SG', code: '+65', country: 'Singapur' },
  { id: 'SX', code: '+1', country: 'Sint Maarten' },
  { id: 'SY', code: '+963', country: 'Siria' },
  { id: 'SO', code: '+252', country: 'Somalia' },
  { id: 'LK', code: '+94', country: 'Sri Lanka' },
  { id: 'ZA', code: '+27', country: 'Sudáfrica' },
  { id: 'SD', code: '+249', country: 'Sudán' },
  { id: 'SS', code: '+211', country: 'Sudán del Sur' },
  { id: 'SE', code: '+46', country: 'Suecia' },
  { id: 'CH', code: '+41', country: 'Suiza' },
  { id: 'SR', code: '+597', country: 'Surinam' },
  { id: 'TH', code: '+66', country: 'Tailandia' },
  { id: 'TW', code: '+886', country: 'Taiwán' },
  { id: 'TZ', code: '+255', country: 'Tanzania' },
  { id: 'TJ', code: '+992', country: 'Tayikistán' },
  { id: 'TL', code: '+670', country: 'Timor Oriental' },
  { id: 'TG', code: '+228', country: 'Togo' },
  { id: 'TK', code: '+690', country: 'Tokelau' },
  { id: 'TO', code: '+676', country: 'Tonga' },
  { id: 'TT', code: '+1', country: 'Trinidad y Tobago' },
  { id: 'TN', code: '+216', country: 'Túnez' },
  { id: 'TM', code: '+993', country: 'Turkmenistán' },
  { id: 'TR', code: '+90', country: 'Turquía' },
  { id: 'TV', code: '+688', country: 'Tuvalu' },
  { id: 'UA', code: '+380', country: 'Ucrania' },
  { id: 'UG', code: '+256', country: 'Uganda' },
  { id: 'UY', code: '+598', country: 'Uruguay' },
  { id: 'UZ', code: '+998', country: 'Uzbekistán' },
  { id: 'VU', code: '+678', country: 'Vanuatu' },
  { id: 'VA', code: '+39', country: 'Vaticano' },
  { id: 'VE', code: '+58', country: 'Venezuela' },
  { id: 'VN', code: '+84', country: 'Vietnam' },
  { id: 'WF', code: '+681', country: 'Wallis y Futuna' },
  { id: 'YE', code: '+967', country: 'Yemen' },
  { id: 'DJ', code: '+253', country: 'Yibuti' },
  { id: 'ZM', code: '+260', country: 'Zambia' },
  { id: 'ZW', code: '+263', country: 'Zimbabue' },
].sort((a, b) => a.country.localeCompare(b.country, 'es'));

const POR_ID = Object.fromEntries(PAISES.map((p) => [p.id, p]));

export const PAISES_FRECUENTES = IDS_FRECUENTES
  .map((id) => POR_ID[id])
  .sort((a, b) => a.country.localeCompare(b.country, 'es'));

export const TODOS_LOS_PAISES = PAISES;

export const paisPorId = (id) => POR_ID[id] || POR_ID[CODIGO_PAIS_DEFAULT];

/** Prefijo telefónico ("+591") del país elegido; Chile si el id no existe. */
export const prefijoDePais = (id) => paisPorId(id).code;

/** Bandera emoji a partir del código ISO ("BO" → 🇧🇴). */
export const banderaDePais = (id) =>
  String.fromCodePoint(...[...id].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));

// Minúsculas y sin tildes, para que "peru" encuentre "Perú".
const normalizar = (texto) =>
  texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

/**
 * ¿El país calza con lo que el visitante escribió en el buscador? Busca por
 * nombre ("bol", "peru", "dominicana") o por código ("591", "+591").
 */
export const paisCalzaConBusqueda = (pais, busqueda) => {
  const texto = normalizar(busqueda);
  if (!texto) return true;
  const soloDigitos = texto.replace(/^\+/, '');
  if (/^\d+$/.test(soloDigitos)) return pais.code.slice(1).startsWith(soloDigitos);
  // Por inicio de palabra: "bo" trae Bolivia y Bosnia, no Cabo Verde.
  const nombre = normalizar(pais.country);
  return nombre.startsWith(texto)
    || nombre.split(/[\s/-]+/).some((palabra) => palabra.startsWith(texto))
    || pais.id.toLowerCase() === texto;
};

// Zona horaria del navegador → país. Es más confiable que el idioma (un
// boliviano con el iPhone en "es-ES" sigue teniendo America/La_Paz).
const PAIS_POR_ZONA = {
  'America/Santiago': 'CL', 'America/Punta_Arenas': 'CL', 'Pacific/Easter': 'CL',
  'America/La_Paz': 'BO', 'America/Lima': 'PE', 'America/Bogota': 'CO',
  'America/Guayaquil': 'EC', 'Pacific/Galapagos': 'EC', 'America/Caracas': 'VE',
  'America/Asuncion': 'PY', 'America/Montevideo': 'UY',
  'America/Mexico_City': 'MX', 'America/Monterrey': 'MX', 'America/Merida': 'MX',
  'America/Cancun': 'MX', 'America/Chihuahua': 'MX', 'America/Mazatlan': 'MX',
  'America/Tijuana': 'MX', 'America/Hermosillo': 'MX', 'America/Bahia_Banderas': 'MX',
  'America/Guatemala': 'GT', 'America/El_Salvador': 'SV', 'America/Tegucigalpa': 'HN',
  'America/Managua': 'NI', 'America/Costa_Rica': 'CR', 'America/Panama': 'PA',
  'America/Havana': 'CU', 'America/Santo_Domingo': 'DO', 'America/Puerto_Rico': 'PR',
  'Europe/Madrid': 'ES', 'Atlantic/Canary': 'ES', 'Africa/Ceuta': 'ES',
  'Europe/Lisbon': 'PT', 'Europe/London': 'GB', 'Europe/Paris': 'FR',
  'Europe/Berlin': 'DE', 'Europe/Rome': 'IT', 'Europe/Amsterdam': 'NL',
  'Europe/Zurich': 'CH', 'Europe/Dublin': 'IE',
  'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Australia/Brisbane': 'AU',
  'Australia/Perth': 'AU', 'Australia/Adelaide': 'AU', 'Pacific/Auckland': 'NZ',
  'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'America/Montreal': 'CA',
  'America/Edmonton': 'CA', 'America/Winnipeg': 'CA', 'America/Halifax': 'CA',
  'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US',
  'America/Phoenix': 'US', 'America/Los_Angeles': 'US', 'America/Anchorage': 'US',
  'Pacific/Honolulu': 'US', 'America/Detroit': 'US',
};

/**
 * País más probable del visitante: primero por zona horaria, después por la
 * región del idioma ("es-BO"), y si no hay pista, Chile.
 */
export const detectarPaisDelVisitante = () => {
  try {
    const zona = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (zona && zona.startsWith('America/Argentina/')) return 'AR';
    if (zona === 'America/Buenos_Aires') return 'AR';
    if (zona && zona.startsWith('America/') && /Sao_Paulo|Manaus|Fortaleza|Recife|Bahia|Belem|Cuiaba/.test(zona)) return 'BR';
    if (PAIS_POR_ZONA[zona]) return PAIS_POR_ZONA[zona];
  } catch (e) {
    // Navegador sin Intl: se sigue con el idioma.
  }
  const idiomas = (typeof navigator !== 'undefined' && (navigator.languages || [navigator.language])) || [];
  for (const idioma of idiomas) {
    const region = (idioma || '').split('-')[1];
    if (region && POR_ID[region.toUpperCase()]) return region.toUpperCase();
  }
  return CODIGO_PAIS_DEFAULT;
};

// Cuando varios países comparten prefijo y el número no dice cuál es, el más
// probable para esta audiencia.
const PREFERIDO_POR_PREFIJO = {
  '+1': 'US', '+7': 'RU', '+39': 'IT', '+262': 'RE', '+590': 'GP', '+599': 'CW',
};

/**
 * Si el visitante escribe o pega el número con código ("+591 71234567" o
 * "0059171234567"), separa el país del número local. Devuelve null si el texto
 * no empieza con + / 00 o si el prefijo todavía no calza con ningún país.
 * Si el país elegido ya tiene ese prefijo, se respeta (Rep. Dominicana con +1
 * no salta a USA).
 */
export const separarPrefijo = (texto, idActual) => {
  const limpio = texto.trim();
  let digitos;
  if (limpio.startsWith('+')) digitos = limpio.slice(1).replace(/\D/g, '');
  else if (limpio.startsWith('00')) digitos = limpio.slice(2).replace(/\D/g, '');
  else return null;

  // Los prefijos telefónicos no son prefijo uno de otro: el primero que calza
  // es el correcto.
  for (let largo = 1; largo <= 3 && largo <= digitos.length; largo += 1) {
    const prefijo = `+${digitos.slice(0, largo)}`;
    const candidatos = PAISES.filter((p) => p.code === prefijo);
    if (candidatos.length) {
      const actual = POR_ID[idActual];
      const id = actual && actual.code === prefijo
        ? actual.id
        : PREFERIDO_POR_PREFIJO[prefijo] || candidatos[0].id;
      return { pais: id, numero: digitos.slice(largo) };
    }
  }
  return null;
};
